import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Cookies, CookiesProvider } from 'react-cookie';
import { initSentry } from 'src/startup';
import { Providers } from 'src/providers';
import App from 'src/App';
import { FullPageSpinner } from 'src/components/Spinner';
import { installChunkErrorListener } from 'src/utils/chunk-error-handler';
import 'src/index.css';
import 'src/services/i18n/i18n';

initSentry();
installChunkErrorListener();

export const cookies = new Cookies();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Providers>
      <CookiesProvider cookies={cookies}>
        <Suspense fallback={<FullPageSpinner />}>
          <App />
        </Suspense>
      </CookiesProvider>
    </Providers>
  </React.StrictMode>,
);
